<template>
  <template-corporation
    :hasFinalTaxType="hasFinalTaxType"
    :fact="fact"
    :showBusiness="showBusiness"
    :pathName="pathName"
  >
  </template-corporation>
</template>

<script>
export default {
  name: "CorpNormalNotRegister",
  props: ["hasFinalTaxType"],
  data() {
    return {
      showBusiness: false,
      pathName: "corp_normal_not_register",
      fact: [
        "การไม่จด VAT ทำให้คุณไม่มีหลักฐานเพื่อช่วยในการขอเครดิตจากธนาคารในกรณีที่คุณต้องการเงินทุนเพื่อขยายกิจการในอนาคต",
        "การไม่จด VAT ทำให้คุณอยู่อย่างหวาดกลัวไม่สามารถ Promote ผ่านช่องทาง Mass Communication ต่างๆ ได้",
      ],
    };
  },
  methods: {
    goVatDefinition() {
      this.$router.push({
        path: "/info/vat_definition",
      });
    },
    goVatBenefit() {
      this.$router.push({
        path: "/info/vat_benefit",
      });
    },
    goPurchaseTax() {
      this.$router.push({
        path: "/info/purchase_tax",
      });
    },
  },
};
</script>

<style scoped>
.lable-alert {
  color: #f45a49;
  font-weight: bold;
}
</style>
